Vue.component('ack-dream-team', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-dream-team',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-dream-team mounted');
		this.setPageIsLoading(false);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'dream-team-page',
			offices: [
				{
					title: 'Taiwan Headquarters',
					address: '11493, Taipei City, Neihu District, Section 1, Neihu Rd, No. 322, 6F',
					phone: '+(886) 2 7737 8330',
					email: 'sales@ackuretta.com marketing@ackuretta.com support@ackuretta.com',
				},
				{
					title: 'North America Office',
					address: '5900 Balcones Dr Ste 11647, Austin Texas 78731-4257',
					phone: null,
					email: 'northamerica.office@ackuretta.com',
				},
				{
					title: 'Europe Office',
					address: '38, Cours Eugenie, Lyon 69003, France',
					phone: '+(33) 640794082',
					email: 'europe.office@ackuretta.com',
				},
				{
					title: 'India Office',
					address:
						'85, Sheriff House, 2F, Richmond Rd, Richmond Town, Bengaluru, Karnataka 560025, India',
					phone: '+(91) 80 4008 7000',
					email: 'india.office@ackuretta.com',
				},
			],
			teamMembers: [
				{
					title: 'Taiwan Headquarters',
					members: [
						{
							name: 'Ayush Bagla',
							position: 'CEO',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Ayush.png',
							linkedin: 'https://www.linkedin.com/in/ayush-bagla98863/',
						},
						{
							name: 'Thomas Wu',
							position: 'CTO',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Thomas.png',
							linkedin: 'team_member_linkedin_url',
						},
						{
							name: 'Shawn Huang',
							position: 'Technical Manager',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Shawn.png',
							linkedin: 'https://www.linkedin.com/in/huang-cheng-yu-50814895/',
						},
						{
							name: 'Alexis Miche',
							position: 'Product Manager',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Alexis.png',
							linkedin: 'https://www.linkedin.com/in/alexis-mich%C3%A9/',
						},
						{
							name: 'Guillermo Alvarez',
							position: 'Marketing Operations Lead',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Memo.png',
							linkedin: 'https://www.linkedin.com/in/guillermo-alvarez-valadez/',
						},
						{
							name: 'Barry Han',
							position: 'Head of OEM & Direct Sales',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Barry.png',
							linkedin: 'team_member_linkedin_url',
						},
						{
							name: 'Caroline Wirrankoski',
							position: 'Head of Customer Success',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Caroline.png',
							linkedin: 'team_member_linkedin_url',
						},
					],
				},
				{
					title: 'Americas',
					members: [
						{
							name: 'Joe Gober',
							position: 'General Manager, Americas',
							photo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Joe.G.png?v=1744781713',
							linkedin: 'https://www.linkedin.com/in/joe-gober-8767ba26/',
						},
						{
							name: 'Cheri Booth',
							position: 'Marketing Manager, Americas',
							photo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Cheri.png?v=1744697136',
							linkedin: 'https://www.linkedin.com/in/cheri-booth-b529304b/',
						},
						{
							name: 'Diana Tinjaca',
							position: 'Americas Training and Support',
							photo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Diana.png?v=1744697137',
							linkedin: '',
						},
						{
							name: 'Laura Brizuela',
							position: 'Americas Training and Support',
							photo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Laura.png?v=1744697136',
							linkedin: '',
						},
					],
				},
				{
					title: 'Asia',
					members: [
						{
							name: 'Daniel Mervin',
							position: 'APAC Regional Manager',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Daniel-Mervin.png',
							linkedin: 'https://www.linkedin.com/in/daniel-mervin-8870b0152/',
						},
						{
							name: 'Jasmine Ong',
							position: 'APAC Partner Program Manager',
							photo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Jasmine.png?v=1711363112',
							linkedin: 'https://www.linkedin.com/in/jasmine-ong091016/',
						},
					],
				},
				{
					title: 'MEA',
					members: [
						{
							name: 'Nevine Saaed',
							position: 'MEA Regional Sales Manager',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Nevine.png',
							linkedin: 'https://www.linkedin.com/in/nevine-aboud-439b11111',
						},
						{
							name: 'Lilian Cassaigne',
							position: 'EMEA Training and Support',
							photo: 'https://cdn.ackuretta.com/public/dream-team/Lilian.png',
							linkedin: 'https://www.linkedin.com/in/lilian-cassaigne-89b618111/',
						},
					],
				},
			],
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
